import './BFixedLogo.css';

/**
 * Fixed background logo watermark on the right side.
 */
export function BFixedLogo() {
  return (
    <img
      src="/tasty-logo.png"
      alt=""
      className="b-fixed-logo"
      aria-hidden="true"
    />
  );
}
